import { render, staticRenderFns } from "./DamaServices.vue?vue&type=template&id=3c74ebb9&"
import script from "./DamaServices.vue?vue&type=script&lang=js&"
export * from "./DamaServices.vue?vue&type=script&lang=js&"
import style0 from "./DamaServices.vue?vue&type=style&index=0&id=3c74ebb9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports